import React, { useEffect } from 'react';
import useMenuStore from 'stores/menuStore';
import useScrollspyStore from 'stores/scrollspyStore';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import ScrollspyMobile from 'components/scrollspy/ScrollspyMobile';

const NavMobileButtons = () => {
  const { navClasses, menuChangeAttrMobile, menuChangeNavClasses } = useMenuStore();
  const { items: scrollspyItems } = useScrollspyStore();

  // Starts mobile menu opening sequence
  const showMobileMenu = (e) => {
    e.preventDefault();
    menuChangeAttrMobile(true);
    let newNavClasses = {
      ...navClasses,
      'mobile-top-out': true,
      'mobile-top-in': false,
      'mobile-top-ready': false,
    };
    menuChangeNavClasses(newNavClasses);
    setTimeout(() => {
      newNavClasses = {
        ...newNavClasses,
        'mobile-top-out': false,
        'mobile-side-ready': true,
      };
      menuChangeNavClasses(newNavClasses);
    }, 200);
    setTimeout(() => {
      newNavClasses = {
        ...newNavClasses,
        'mobile-side-in': true,
      };
      menuChangeNavClasses(newNavClasses);
    }, 230);
  };

  // Starts mobile menu closing sequence
  const hideMobileMenu = () => {
    let newNavClasses = {
      ...navClasses,
      'mobile-side-out': true,
      'mobile-side-ready': true,
      'mobile-side-in': false,
    };
    menuChangeNavClasses(newNavClasses);
    setTimeout(() => {
      newNavClasses = {
        ...newNavClasses,
        'mobile-side-ready': false,
        'mobile-side-out': false,
        'mobile-top-ready': true,
      };
      menuChangeNavClasses(newNavClasses);
    }, 200);
    setTimeout(() => {
      newNavClasses = {
        ...newNavClasses,
        'mobile-top-in': true,
        'mobile-top-ready': true,
      };
      menuChangeNavClasses(newNavClasses);
      menuChangeAttrMobile(false);
    }, 230);
  };

  useEffect(() => {
    if (navClasses && navClasses['mobile-side-in']) {
      window.addEventListener('click', hideMobileMenu);
    }
    return () => {
      window.removeEventListener('click', hideMobileMenu);
    };
    // eslint-disable-next-line
  }, [navClasses]);

  return (
    <div className="mobile-buttons-container">
      {scrollspyItems && scrollspyItems.length > 0 && <ScrollspyMobile items={scrollspyItems} />}
      <a href="#/" id="mobileMenuButton" className="menu-button" onClick={showMobileMenu}>
        <CsLineIcons icon="menu" />
      </a>
    </div>
  );
};
export default React.memo(NavMobileButtons);
